import React, { Component, useState } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import axios from "axios";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import {
  FormControl,
  Dropdown,
  Button,
} from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import TotalSummary from "../groupRunningSummary/totalSummary";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";

class GroupRunningSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: "Select start date",
      dataPlaceholder2: "Select end date",
      assetShow: false,
      globalDate: "",
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      calendarSelect: false,
      calendarSelect2: false,
      ReportDate: new Date(),
      calendarStartDate: new Date(),
      calendarEndDate: new Date(),
      calendarShow: false,
      calendarShow2: false,
      endDate: "",
      checked: true,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetIdArray: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      groupName: "",
      customerName: "",
      timeZone: localStorage.getItem("timeZone"),
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.maxDate = moment().subtract(1, 'days').toDate();
  }
  async componentDidMount() {
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ groupDetails: GroupList.data });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  handleGroupDropDown = (groupid, groupname, customername) => {
    this.setState({
      groupId: groupid,
      groupName: groupname,
      customerName: customername,
    });

    this.getAssets(groupid);
  };
  getAssets = async (groupid) => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${groupid}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });

      let assetIdArray = AssetList.data.includedelements;
      this.setState({ assetIdArray: assetIdArray });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, id) => {
    this.setState({ assetLoader: true });
    this.groupId = id;
    this.setState({
      groupId: id,
      groupCustomerName: customer,
      groupGeneralName: name,
      assetCustomerName: "",
      assetGeneralName: "",
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    this.getAssets();
  };
  handleAssetSelection = (asset, name, id) => {
    this.setState({
      assetId: id,
      assetCustomerName: asset,
      assetGeneralName: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
    });
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    this.setState({
      calendarSelect: true,
      calendarStartDate: date,
      globalDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  calendarFunction2 = () => {
    if (this.state.globalDate != "") {
      this.setState({
        calendarShow2: !this.state.calendarShow2,
      });
    } else {
      alert("select start date");
    }
  };
  onChangeDate2 = (date) => {
    this.setState({
      calendarSelect2: true,
      calendarEndDate: date,
      endDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleCheckup = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };
  handleCreateReport = async () => {
    this.setState({
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/GroupRunningSummary`,
        {
          AssetIds: this.state.assetIdArray,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          EndDate: this.state.endDate,
          UseFiltering: this.state.checked,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  render() {
    const calendarReport = this.state.calendarShow ? (
      <div
        ref={this.setWrapperRef}
        className="ParentCalender"
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={this.maxDate}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );

    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(3, "months").toDate() >
              this.maxDate
                ? this.maxDate
                : moment(this.state.globalDate).add(3, "months").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <button
        href=""
        className="dropDownSearch"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
        <i className="fa fa-th" />
      </button>
    ));

    const CustomMenu = React.forwardRef(
      ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        const [value, setValue] = useState("");

        return (
          <div
            ref={ref}
            style={style}
            className={className}
            aria-labelledby={labeledBy}
          >
            <FormControl
              autoFocus
              className="mx-3 my-2 w-auto"
              placeholder="Type to filter..."
              onChange={(e) => setValue(e.target.value)}
              value={value}
            />
            <ul className="list-unstyled">
              {React.Children.toArray(children).filter(
                (child) =>
                  !value || child.props.children.toLowerCase().includes(value)
              )}
            </ul>
          </div>
        );
      }
    );
    return (
      <Layout>
        <Helmet>
          <title>Group Running Summary</title>
        </Helmet>

        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <div className="headingContainer">
              <h2 className="mainHeading">
                Group Running Summary <span>v1.8.0</span>
              </h2>
              <i
                className={
                  this.props.headerHide
                    ? `fa fa-window-restore`
                    : `fa fa-window-maximize`
                }
                onClick={this.handleWindow}
              />
            </div>
            <hr />
            <div className="inputFormGroup">
              <div className="inputElement">
                <Dropdown>
                  <Dropdown.Toggle
                    as={CustomToggle}
                    id="dropdown-custom-components"
                  >
                    {this.state.groupName != "" ? (
                      <span>{`${this.state.groupName} - ${this.state.customerName}`}</span>
                    ) : (
                      "Select Group"
                    )}{" "}
                  </Dropdown.Toggle>

                  <Dropdown.Menu as={CustomMenu}>
                    {this.state.groupDetails.map((item, index) => {
                      return (
                        <Dropdown.Item
                          key={item.groupId}
                          onClick={() =>
                            this.handleGroupDropDown(
                              item.groupId,
                              item.groupName,
                              item.customername
                            )
                          }
                        >
                          {` ${item.customername} - ${item.groupName} `}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction}
                  dropDown={calendarReport}
                  placeholder={this.state.dataPlaceholder}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction2}
                  dropDown={calendarReport2}
                  placeholder={this.state.dataPlaceholder2}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                {/* <p>
                  <input
                    type="checkbox"
                    onChange={this.handleCheckup}
                    checked={this.state.checked}
                  ></input>{" "}
                  Use Filtering{" "}
                </p> */}

                {this.state.customerName != "" &&
                this.state.calendarSelect &&
                this.state.calendarSelect2 ? (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                ) : (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                )}
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <div className="loaderLine">
                    <h1>Something Went Wrong...!</h1>
                  </div>
                ) : (
                  <React.Fragment>
                    {this.state.reportDetails != "" && (
                      <TotalSummary reportDetails={this.state.reportDetails}
                      customerName = {this.state.customerName}
                      groupName = {this.state.groupName}
                      timeZone = {this.state.timeZone}
                       />
                    )}
                    {/* {this.state.reportDetails != "" && (
                      <HourlyTotalSummary
                        reportDetails={this.state.reportDetails}
                        groupName = {this.state.groupName}
                        timeZone = {this.state.calendarStartDate}
                      />
                    )} */}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupRunningSummary);
